import React, { useCallback, useState } from "react";
import { useIntl } from "react-intl";
import { PeekDivider, PeekPaper, PeekStack, PeekTypography } from "@piiqtechnologies/ui-components";
import messages from "./messages.i18n";
import { SearchSelectForm } from "./search-select-form";
import { ManualEntryForm } from "./manual-entry-form";
export const CommunitySearch = ({ onSelect }) => {
    const intl = useIntl();
    const [isManualMode, setIsManualMode] = useState(false);
    const handleEnterManualMode = useCallback(() => {
        setIsManualMode(true);
        onSelect(null);
    }, [onSelect]);
    const handleRevertToSearch = useCallback(() => {
        setIsManualMode(false);
        onSelect(null);
    }, [onSelect]);
    return (React.createElement(PeekPaper, { elevation: 1, sx: { borderRadius: 2, width: "100%", maxWidth: "600px" } },
        React.createElement(PeekStack, { direction: "column", gap: 1, padding: 2 },
            React.createElement(PeekTypography, { variant: "h3", fontWeight: "fontWeightMedium", textAlign: "center" }, intl.formatMessage(messages.title)),
            React.createElement(PeekDivider, { light: true }),
            !isManualMode ? (React.createElement(SearchSelectForm, { onSelect: onSelect, onManualEntry: handleEnterManualMode })) : (React.createElement(ManualEntryForm, { onSelect: onSelect, onRevertToSearch: handleRevertToSearch })))));
};
export default CommunitySearch;
